'use strict';
import productTile from '../product-tile';
import recommendations  from './product/recommendations';

export default {
	init: function () {
		productTile.init();
		recommendations.init();
		$('#homepage-hero').slick({
			arrows: true,
			autoplay: true,
			autoplaySpeed: 4000,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [{
				breakpoint: 480,
				settings: {
					arrows: false
				}
			}]
		});
		$('.sub-feature-article').slick({
			arrows: false,
			dots: false,
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
					dots: true
				}
			}]
		});
		initEinsteinRecommendations();
		screenResizeHandler();
	}
};

// re-initialize Einstein Recommendation carousel
function initEinsteinRecommendations() {
	$(window).on("load", function() {
		setTimeout(function() {
			recommendations.init();
			// to reinit recommended product's quantity dropdown 
			$('.carousel-recommendations select').selectmenu();
		}, 5000);	
	});
}

function screenResizeHandler() {
	// Store the window width
    var winWidth = $(window).width();

	$(window).on('resize orientationchange', function () {
		// to prevent calling of resize event in IOS devices while scrolling
        if ($(window).width() != winWidth) {
            // Update the window width for next time
            winWidth = $(window).width();            
			// Do stuff here
			var $recommendationCarousel = $('.recommendation-container .carousel-recommendations');			
			if ($recommendationCarousel.hasClass('slick-initialized')) {
				$recommendationCarousel.slick('destroy');
				recommendations.init();
				$('.carousel-recommendations select').selectmenu();
			}
        }
	});
}